/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, BoxView, ActionButton, Text, TextField } from '@components/atoms'

const InquiryManagementPage = () => {
	return (
		<View css={style}>
			<BoxView title="문의 게시판 관리"></BoxView>
		</View>
	)
}

export default InquiryManagementPage

const style = css({})
